import {combineReducers} from "redux";

import lotto5 from "./lotto5"
const analyzeReportReducer = combineReducers({
    lotto5
})

export default analyzeReportReducer